import axis from './axis'
import drawing from './drawing'

export default (selection, chart, data, defs) => {
  selection.each(function () {
    let beaker = selection.selectAll('g.beaker-group')
                          .data(data)
      , enter = beaker.enter()
                      .append('g')
                      .attr('class', 'beaker-group')

    beaker.exit().remove()

    beaker = beaker.merge(enter)

    beaker.call(axis)

    let axisWidth = beaker.select('.axis').node().getBBox().width - 10 // 10 matches the line length

    beaker.attr('transform', d => {
            let dim = d.block.dimensions
              , xOffset = 0

            if (d.width < d.block.dimensions.width) {
              xOffset = (d.block.dimensions.width - d.width) / 2
            }
            // return `translate(${d.block.dimensions.x + xOffset + padding}, 0)`
            return `translate(${dim.x + axisWidth + xOffset}, ${dim.y + d.ry})`
          })
          .call(drawing, chart, defs, axisWidth)
  })
}
